import { easyPost } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const userClear = easyPost('protoco.user.clear');
